import { Tag } from './../types'

const tags: { [key: string]: Tag } = {
  founder: { name: 'Founder' },
  cto: { name: 'CTO' },

  vr: { name: 'vr' },
  ar: { name: 'ar' },
  unity: { name: 'unity' },
  ios: { name: 'ios' },
  android: { name: 'android' },
  cSharp: { name: 'c#' },
  unreal: { name: 'unreal' },
  maya: { name: 'maya' },
  webVr: { name: 'webVr' },
  vuejs: { name: 'vuejs' },
  node: { name: 'node' },
  aws: { name: 'aws' },
  pymel: { name: 'pymel' },
  serverless: { name: 'serverless' },
  mentorship: { name: 'Mentorship' },
  speaking: { name: 'Speaking' }
}
export default tags
